// ENG-30290 -- Secondary/Tertiary Phone and Email. Shared between
// useMiniProfileSections.js (renders the fields, populates defaultValues
// from the loaded record) and buildSavePayload.js (turns the two flat
// Secondary/Tertiary slots back into the `additionalPhones`/`additionalEmails`
// array shape the API contract expects) so the lowercase<->title-case Type
// mapping and the Secondary/Tertiary ordering rule each live in exactly one
// place, per the API payload shape decision in CONTEXT.md.
//
// Backend values (fortress-backend/src/domain/constants/contactTypes.js):
// PHONE_TYPES = ['mobile','work','home','other'], EMAIL_TYPES = ['personal',
// 'work','other'], DEFAULT_PHONE_TYPE = 'mobile', DEFAULT_EMAIL_TYPE =
// 'personal'. Mirrored here as plain constants -- fortress-backend isn't a
// dependency of this package, so these can't be imported directly -- so a
// future change on either side is at least a visible two-file diff instead of
// a silent mismatch.
export const DEFAULT_PHONE_TYPE = 'mobile';
export const DEFAULT_EMAIL_TYPE = 'personal';

// Stored values are lowercase; the ticket's Type dropdown labels are
// title-case. This is the one place that mapping exists -- the Type
// SingleSelect fields in useMiniProfileSections.js consume these arrays
// directly, and nothing else (frontend or backend) needs its own copy of it.
export const ADDITIONAL_PHONE_TYPE_OPTIONS = [
  { value: 'mobile', text: 'Mobile' },
  { value: 'work', text: 'Work' },
  { value: 'home', text: 'Home' },
  { value: 'other', text: 'Other' },
];

export const ADDITIONAL_EMAIL_TYPE_OPTIONS = [
  { value: 'personal', text: 'Personal' },
  { value: 'work', text: 'Work' },
  { value: 'other', text: 'Other' },
];

// Secondary = the older of the (up to two) non-primary rows on the loaded
// record, Tertiary = the newer -- deterministic regardless of whatever order
// the backend's getByContactId happens to return them in, since
// CustomerContactProcessor.processEmails/processPhones always fully deletes
// and recreates every ContactEmail/ContactPhone row on every save (see
// CONTEXT.md's payload shape decision), so array order there is create-order
// of the most recent save, not something a user assigned intentionally. Only
// the first two survive; any further stale rows (e.g. left over from data
// entered before this two-slot cap existed) are silently ignored -- not
// shown, not resaved, not deleted either (an omitted slot is never touched).
export const getAdditionalContactEntries = (entries = []) =>
  (entries ?? [])
    .filter((entry) => !entry?.isPrimary)
    .slice()
    .sort((a, b) => new Date(a?.createdAt ?? 0) - new Date(b?.createdAt ?? 0))
    .slice(0, 2);
